var map = {
	"../pages/dashboard/dashboard.module": [
		"./src/pages/dashboard/dashboard.module.ts",
		"common",
		"pages-dashboard-dashboard-module"
	],
	"../pages/new-project/new-project.module": [
		"./src/pages/new-project/new-project.module.ts",
		"common",
		"pages-new-project-new-project-module"
	],
	"../pages/project-view/project-view.module": [
		"./src/pages/project-view/project-view.module.ts",
		"common",
		"pages-project-view-project-view-module"
	],
	"../pages/sign-up/sign-up.module": [
		"./src/pages/sign-up/sign-up.module.ts",
		"pages-sign-up-sign-up-module"
	],
	"src/pages/new-project/new-project.module": [
		"./src/pages/new-project/new-project.module.ts",
		"common",
		"pages-new-project-new-project-module"
	],
	"src/pages/projects-list/projects-list.module": [
		"./src/pages/projects-list/projects-list.module.ts",
		"common",
		"src-pages-projects-list-projects-list-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;